import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import { getDatabase, ref, set, push, get, child } from "firebase/database";
import { getAuth } from "firebase/auth";
import { useFirebase } from "../FirebaseProvider";
import { Link } from "react-router-dom";
import SearchAppBar from "./NavBar";
import { EditorState, convertToRaw, ContentState } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
import "./EditorCSS.css";
import Image_Upload from "./Image_Upload";
import Alert from "@mui/material/Alert";
import ActionAlerts from "./Alerts";
import { useState } from "react";
import { Grid } from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import { BorderAllRounded } from "@mui/icons-material";
import Recipes from "./Header";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import GifConverter from "./GifConverter";

export default function RecipeEditor(props) {
  let { RecipeId } = useParams();
  console.log(RecipeId);
  const [value, setValue] = React.useState({
    RecipeName: "",
    IngredientList: "",
    Directions: "",
    ProTips: "",
    Date: new Date().toLocaleDateString(),
  });
  const firebase = useFirebase();

  const [recipe, setRecipe] = React.useState(null);
  const [loading, setLoading] = React.useState(true);

  const [directionsState, setDirectionsState] = React.useState();
  const [ingredientsState, setIngredientsState] = React.useState();

  const [gif, setGif] = React.useState();

  React.useEffect(() => {
    console.log("I RAN");
    if (firebase) {
      console.log("FIREBASED");
      setLoading(true);
      const database = getDatabase(firebase.app);
      const dbRef = ref(database);
      get(child(dbRef, `recipes/${RecipeId}`)).then((snapshot) => {
        console.log(snapshot);
        if (snapshot.exists()) {
          const recipeObject = snapshot.val();
          console.log(recipeObject);
          console.log(snapshot.val());
          setRecipe(recipeObject);
        } else {
          console.log("No data available");
        }
      });
    }
  }, [firebase, RecipeId]);

  React.useEffect(() => {
    if (recipe) {
      setValue({
        ...recipe,
        RecipeName: recipe.RecipeName,
        Date: new Date().toLocaleDateString(),
      });
      console.log(recipe);

      // TO DO: SET INITIAL IMAGE FROM LOCAL STORAGE
      localStorage.setItem("RecipeName", recipe.RecipeName);
      // localStorage.setItem("PhotoUrl", recipe.PhotoUrl);
      localStorage.setItem("directionsState", recipe.Directions);
      localStorage.setItem("ingredientsState", recipe.IngredientList);

      setDirectionsState(getInitialDirectionState());
      setIngredientsState(getInitialIngredientsState());
      setLoading(false);
    }
  }, [recipe]);

  const [editorState, setEditorState] = React.useState(
    EditorState.createEmpty()
  );

  const onEditorStateChange = (editorState) => {
    setEditorState({
      editorState,
    });
  };

  // start test
  const getInitialIngredientsState = () => {
    const html = localStorage.getItem("ingredientsState");
    if (html) {
      const contentBlock = htmlToDraft(html);
      if (contentBlock) {
        const contentState = ContentState.createFromBlockArray(
          contentBlock.contentBlocks
        );
        const editorState = EditorState.createWithContent(contentState);
        return editorState;
      } else {
        return EditorState.createEmpty();
      }
    }
  };

  const getInitialDirectionState = () => {
    const html = localStorage.getItem("directionsState");
    if (html) {
      const contentBlock = htmlToDraft(html);
      if (contentBlock) {
        const contentState = ContentState.createFromBlockArray(
          contentBlock.contentBlocks
        );
        const editorState = EditorState.createWithContent(contentState);
        return editorState;
      } else {
        return EditorState.createEmpty();
      }
    }
  };

  React.useEffect(() => {
    if (!loading) {
      console.log("I TAN");
      getInitialDirectionState();
      getInitialIngredientsState();
    }
  }, [loading]);

  const onDirectionsStateChange = (directionsState) => {
    setEditorState({
      directionsState,
    });
    console.log("function called in general");
    localStorage.setItem("directionsState", directionsState);
  };

  const onIngredientsStateChange = (ingredientsState) => {
    setEditorState({
      ingredientsState,
    });
    console.log("function called in general");
    localStorage.setItem("ingredientsState", ingredientsState);
  };

  // end test

  const handleChange = (event, field) => {
    // setValue(event.target.value);
    setValue({ ...value, [field]: event.target.value });
    localStorage.setItem(field, event.target.value);
  };

  const handleChangeImg = (downloadURL) => {
    // setValue(event.target.value);
    setValue({ ...value, PhotoUrl: downloadURL });
    localStorage.setItem("PhotoUrl", downloadURL);
  };

  // Alert Testing Start
  const [showAlert, setShowAlert] = useState(false);
  const [showError, setShowError] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");

  const handleButtonClick = () => {
    setShowAlert(true);
  };

  const handleCloseAlert = () => {
    setShowAlert(false);
  };

  const handleCloseError = () => {
    setShowError(false);
  };
  // Alert Testing End

  // function submit_and_alert(e) {
  //   handleSubmit()
  //   handleButtonClick()
  const success_messages = [
    "Dang, thats a good lookin' recipe...",
    "It appears you did not add enough garlic...",
    "Thank you for seasoning your chicken...",
    "Hear me out... Why not more salt?",
    "Wow, what a recipe!",
    "Clearly you're a professional!",
    "Dang, where did you learn to cook like that?",
  ];
  const get_success_message = () => {
    return success_messages.sort(() => 0.5 - Math.random())[0];
  };
  //  recipeList.sort(() => 0.5 - Math.random());

  // }
  const handleSubmit = async (e) => {
    let messageContentHTML = null;
    let directvar = null;

    setShowError(false);
    setShowAlert(false);

    if (!ingredientsState || !directionsState || !value.RecipeName) {
      setShowError(true);
      return;
    }
    // Add Else:

    if (ingredientsState && ingredientsState.getCurrentContent()) {
      messageContentHTML = draftToHtml(
        convertToRaw(ingredientsState.getCurrentContent())
      );
    }
    // Add Else:
    if (directionsState && directionsState.getCurrentContent()) {
      directvar = draftToHtml(
        convertToRaw(directionsState.getCurrentContent())
      );
    }
    // Add Else:

    const auth = getAuth();
    const user = auth.currentUser;
    e.preventDefault();
    const database = getDatabase(firebase.app);
    const postListRef = ref(database, `recipes/${RecipeId}`);

    // TO DO: Look at firebase docs and look at ways to update values instead of creating new
    try {
      await set(postListRef, {
        ...value,
        IngredientList: messageContentHTML,
        Directions: directvar,
        TimeStamp: new Date().toLocaleString(),
        userId: user.uid,
      });

      setSuccessMessage(get_success_message());
      setShowAlert(true);

      setDirectionsState("");
      setIngredientsState("");
      setEditorState("");

      setValue({
        ...value,
        RecipeName: "",
      });

      localStorage.removeItem("RecipeName");

      localStorage.removeItem("directionsState");
      localStorage.removeItem("ingredientsState");
    } catch (error) {
      console.log(error);
      setShowError(true);
    }
  };

  return (
    // Alert Testing Start

    // Alert Testing
    <Box
      component="form"
      sx={{
        width: "100%",
        minHeight: "100vh",
        bgcolor: "#282c34",
      }}
      noValidate
      autoComplete="off"
    >
      <SearchAppBar />
      
      <Box
        sx={{
          maxWidth: "1200px",
          margin: "0 auto",
          padding: "40px 20px",
          color: "white",
        }}
      >
        {/* Header Section */}
        <Box sx={{ marginBottom: "40px" }}>
          <h1 style={{ fontSize: "2.5rem", marginBottom: "10px", fontWeight: "600" }}>Edit Recipe</h1>
          <p style={{ fontSize: "1.1rem", opacity: 0.8 }}>Update your recipe details</p>
        </Box>

        {/* Alert Messages */}
        <Box sx={{ marginBottom: "30px" }}>
          {showError && (
            <Alert
              severity="error"
              onClose={handleCloseError}
              sx={{ marginBottom: "15px" }}
            >
              Make sure your recipe is completely filled out!
            </Alert>
          )}
          {showAlert && (
            <Alert
              severity="success"
              onClose={handleCloseAlert}
              sx={{ marginBottom: "15px" }}
            >
              {successMessage}
            </Alert>
          )}
        </Box>

        {/* Recipe Name Section */}
        <Box
          sx={{
            bgcolor: "rgba(255, 255, 255, 0.05)",
            borderRadius: "8px",
            padding: "30px",
            marginBottom: "30px",
            border: "1px solid rgba(255, 255, 255, 0.1)",
          }}
        >
          <h2 style={{ fontSize: "1.8rem", marginTop: 0, marginBottom: "20px", color: "#61dafb" }}>Recipe Details</h2>
          
          <Grid container spacing={3} sx={{ marginBottom: "20px" }}>
            <Grid item xs={12} sm={8}>
              <TextField
                fullWidth
                label="Recipe Name"
                placeholder="Enter Recipe Name Here"
                value={value.RecipeName}
                onChange={(e) => handleChange(e, "RecipeName")}
                variant="outlined"
                sx={{
                  "& .MuiOutlinedInput-root": {
                    color: "white",
                    "& fieldset": { borderColor: "rgba(255, 255, 255, 0.3)" },
                    "&:hover fieldset": { borderColor: "rgba(255, 255, 255, 0.5)" },
                    "&.Mui-focused fieldset": { borderColor: "#61dafb" },
                  },
                  "& .MuiOutlinedInput-input::placeholder": {
                    opacity: 0.7,
                  },
                  "& .MuiInputBase-input": {
                    fontSize: "1rem",
                  },
                }}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100%", gap: "15px", flexWrap: "wrap" }}>
                <Box sx={{ textAlign: "center" }}>
                  <p style={{ marginBottom: "10px", opacity: 0.8 }}>Recipe Image</p>
                  <Image_Upload
                    mainState={value.PhotoUrl ? "uploaded" : null}
                    imageUploaded={value.PhotoUrl ? 1 : null}
                    selectedFile={value.PhotoUrl || null}
                    onValueChange={handleChangeImg}
                  />
                </Box>
                <Box sx={{ textAlign: "center" }}>
                  <GifConverter {...{ gif, setGif }} />
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Box>

        {/* Ingredients Section */}
        <Box
          sx={{
            bgcolor: "rgba(255, 255, 255, 0.05)",
            borderRadius: "8px",
            padding: "30px",
            marginBottom: "30px",
            border: "1px solid rgba(255, 255, 255, 0.1)",
          }}
        >
          <h2 style={{ fontSize: "1.8rem", marginTop: 0, marginBottom: "20px", color: "#99fb61" }}>Ingredients</h2>
          <Box sx={{ 
            bgcolor: "rgba(0, 0, 0, 0.2)",
            borderRadius: "6px",
            padding: "15px",
            "& .demo-wrapper": { bgcolor: "transparent" },
            "& .demo-editor": { 
              color: "white",
              minHeight: "200px",
              padding: "10px",
              borderRadius: "4px",
            },
          }}>
            <Editor
              toolbar={{
                options: ["inline", "list"],
                list: {
                  inDropdown: false,
                  className: undefined,
                  component: undefined,
                  dropdownClassName: undefined,
                  options: ["unordered", "ordered"],
                },
                inline: {
                  inDropdown: false,
                  className: undefined,
                  component: undefined,
                  dropdownClassName: undefined,
                  options: ["bold", "underline"],
                },
              }}
              editorState={ingredientsState}
              wrapperClassName="demo-wrapper"
              editorClassName="demo-editor"
              onEditorStateChange={(e) => {
                setIngredientsState && setIngredientsState(e);
                localStorage.setItem(
                  "ingredientsState",
                  draftToHtml(convertToRaw(e.getCurrentContent()))
                );
              }}
            />
          </Box>
        </Box>

        {/* Directions Section */}
        <Box
          sx={{
            bgcolor: "rgba(255, 255, 255, 0.05)",
            borderRadius: "8px",
            padding: "30px",
            marginBottom: "30px",
            border: "1px solid rgba(255, 255, 255, 0.1)",
          }}
        >
          <h2 style={{ fontSize: "1.8rem", marginTop: 0, marginBottom: "20px", color: "#61dafb" }}>Directions</h2>
          <Box sx={{ 
            bgcolor: "rgba(0, 0, 0, 0.2)",
            borderRadius: "6px",
            padding: "15px",
            "& .demo-wrapper": { bgcolor: "transparent" },
            "& .demo-editor": { 
              color: "white",
              minHeight: "250px",
              padding: "10px",
              borderRadius: "4px",
            },
          }}>
            <Editor
              toolbar={{
                options: ["inline", "list"],
                list: {
                  inDropdown: false,
                  className: undefined,
                  component: undefined,
                  dropdownClassName: undefined,
                  options: ["unordered", "ordered"],
                },
                inline: {
                  inDropdown: false,
                  className: undefined,
                  component: undefined,
                  dropdownClassName: undefined,
                  options: ["bold", "underline"],
                },
              }}
              editorState={directionsState}
              wrapperClassName="demo-wrapper"
              editorClassName="demo-editor"
              onEditorStateChange={(e) => {
                setDirectionsState && setDirectionsState(e);
                localStorage.setItem(
                  "directionsState",
                  draftToHtml(convertToRaw(e.getCurrentContent()))
                );
              }}
            />
          </Box>
        </Box>

        {/* Action Buttons */}
        <Box
          sx={{
            display: "flex",
            gap: "20px",
            justifyContent: "center",
            alignItems: "center",
            flexWrap: "wrap",
            marginTop: "40px",
          }}
        >
          <Button
            variant="contained"
            endIcon={<SendIcon sx={{ color: "#282c34" }} />}
            onClick={handleSubmit}
            sx={{
              minWidth: "200px",
              padding: "12px 30px",
              fontSize: "1rem",
              fontWeight: "600",
              bgcolor: "#78E2D6",
              color: "#282c34",
              borderRadius: "6px",
              transition: "all 0.3s ease",
              "&:hover": {
                backgroundColor: "#3CA6A6",
                color: "white",
                transform: "translateY(-2px)",
                boxShadow: "0 8px 16px rgba(97, 218, 251, 0.3)",
              },
            }}
          >
            Update Recipe
          </Button>

          <Button
            component={Link}
            to="/recipeFeed"
            variant="outlined"
            sx={{
              minWidth: "200px",
              padding: "12px 30px",
              fontSize: "1rem",
              fontWeight: "600",
              color: "#FFFFFF",
              border: "2px solid #FFFFFF",
              borderRadius: "6px",
              transition: "all 0.3s ease",
              "&:hover": {
                borderColor: "#3CA6A6",
                backgroundColor: "rgba(60, 166, 166, 0.1)",
                transform: "translateY(-2px)",
              },
            }}
          >
            Recipe Feed
          </Button>
        </Box>
      </Box>
    </Box>
  );
}
